import * as React from "react";
import classNames from "classnames";

import {IAttrs} from "@ok/utils/types/IAttrs";
import {TSID} from "../../../../utils/TSID";
import {ImageTransformations} from "../../../../utils/ImageTransformations";

import classes from "./AvatarCore.styl";

export const AvatarSizes = {
    "16": {
        fn: ImageTransformations.SQR32,
        class: classes["__sz16"],
    },
    "20": {
        fn: ImageTransformations.SQR32,
        class: classes["__sz20"],
    },
    "24": {
        fn: ImageTransformations.SQR32,
        class: classes["__sz24"],
    },
    "32": {
        fn: ImageTransformations.SQR32,
        class: classes["__sz32"],
    },
    "36": {
        fn: ImageTransformations.SQR32,
        class: classes["__sz36"],
    },
    "40": {
        fn: ImageTransformations.SQR40,
        class: classes["__sz40"],
    },
    "44": {
        fn: ImageTransformations.SQR40,
        class: classes["__sz44"],
    },
    "48": {
        fn: ImageTransformations.SQR48,
        class: classes["__sz48"],
    },
    "56": {
        fn: ImageTransformations.SQR56,
        class: classes["__sz56"],
    },
    "64": {
        fn: ImageTransformations.SQR64,
        class: classes["__sz64"],
    },
    "96": {
        fn: ImageTransformations.SQR96,
        class: classes["__sz96"],
    },
    "128": {
        fn: ImageTransformations.SQR128,
        class: classes["__sz128"],
    },
    "223": {
        fn: ImageTransformations.SQR223,
        class: classes["__sz223"],
    }
};

export type IAvatarSize = keyof typeof AvatarSizes;

export interface IAvatarProps {
    size: IAvatarSize;
    className?: string;
    imageClassName?: string;
    round?: boolean;
    lazy?: boolean;
    additionalContent?: () => React.ReactNode;
    attrs?: IAttrs;
    attrsLink?: IAttrs;
    withLink?: boolean;
}

export interface IAvatarCoreProps extends IAvatarProps {
    imageUrl: string;
    href?: string;
    alt?: string;
    useResize?: boolean;
}

export const AvatarCore = (
    {
        size,
        className,
        imageClassName,
        round,
        withLink = true,
        lazy = true,
        imageUrl,
        href,
        alt,
        additionalContent,
        attrs,
        attrsLink
    }: IAvatarCoreProps
) => {

    const avatarClassName = classNames(
        classes["avatar-img"],
        AvatarSizes[size].class,
        {
            [classes["__round"]]: round
        },
        imageClassName,
    );

    const linkClassName = classNames(
        classes["avatar-link"],
        className,
    );

    const image = (
        <img src={imageUrl}
             alt={alt}
             width={Number(size)}
             height={Number(size)}
             className={avatarClassName}
             loading={lazy ? "lazy" : "eager"}
             data-tsid={TSID.attr("avatar_image")}
             {...attrs}
        />
    );

    const avatar = href && withLink ? (
        <a href={href} className={linkClassName} {...attrsLink}>
            {image}
        </a>
    ) : image;

    if (additionalContent) {
        return (
            <div className={classes["avatar-wrapper"]}>
                {additionalContent()}
                {avatar}
            </div>
        );
    }

    return avatar;
};
